import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { CheckCircleOutline as CheckCircleIcon } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";

const Confirmation = () => {
  const navigate = useNavigate();
  const { eventId } = useParams(); // Get eventId from route params

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 120px)",
        backgroundColor: "#f5f5f5",
        padding: "20px",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: "30px",
          maxWidth: "600px",
          textAlign: "center",
          borderRadius: "12px",
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: "150px",
            color: "green",
            marginBottom: "20px",
          }}
        />
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "28px", md: "36px" }, // Bigger font for larger screens
            color: "linear-gradient(90deg, #FF6F61 0%, #D72638 100%)",
            textAlign: "center",
            letterSpacing: "1.5px",
            textShadow: "2px 2px 5px rgba(0,0,0,0.3)", // Soft shadow
            animation: "fadeIn 1.2s ease-in-out",
            mb:2,
            "@keyframes fadeIn": {
              "0%": { opacity: 0, transform: "translateY(-10px)" },
              "100%": { opacity: 1, transform: "translateY(0)" },
            },
          }}
        >
          Registration Successful!
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            fontSize: "16px",
            color: "#555",
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          Thank you for registering. We look forward to seeing you at the event!
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            fontSize: "16px",
            padding: "10px 20px",
            textTransform: "none",
            borderRadius: "8px",
          }}
          onClick={() => navigate(`/event/${eventId}`)}
        >
          View Event Details
        </Button>
      </Paper>
    </Box>
  );
};

export default Confirmation;
